import { render, staticRenderFns } from "./Ticket.vue?vue&type=template&id=11fa1e95&scoped=true&"
import script from "./Ticket.vue?vue&type=script&lang=ts&"
export * from "./Ticket.vue?vue&type=script&lang=ts&"
import style0 from "./Ticket.vue?vue&type=style&index=0&id=11fa1e95&prod&lang=scss&"
import style1 from "./Ticket.vue?vue&type=style&index=1&id=11fa1e95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fa1e95",
  null
  
)

export default component.exports